var $3bf70f65bc45545c$exports = {};
$3bf70f65bc45545c$exports = {
    "clear": `\u{5E0}\u{5E7}\u{5D9}`,
    "invalid": `(\u{5DC}\u{5D0} \u{5D7}\u{5D5}\u{5E7}\u{5D9})`,
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "noResults": `\u{5D0}\u{5D9}\u{5DF} \u{5EA}\u{5D5}\u{5E6}\u{5D0}\u{5D5}\u{5EA}`,
    "valid": `(\u{5EA}\u{5B8}\u{5E7}\u{5B5}\u{5E3})`
};


export {$3bf70f65bc45545c$exports as default};
//# sourceMappingURL=he-IL.mjs.map
